import { render, staticRenderFns } from "./TrialInfo.vue?vue&type=template&id=61875323&scoped=true&"
import script from "./TrialInfo.vue?vue&type=script&lang=ts&"
export * from "./TrialInfo.vue?vue&type=script&lang=ts&"
import style0 from "./TrialInfo.vue?vue&type=style&index=0&id=61875323&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61875323",
  null
  
)

export default component.exports